import { render } from "./Index.vue?vue&type=template&id=590ea70b&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=590ea70b&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=590ea70b&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590ea70b"]])

export default __exports__